import { render, staticRenderFns } from "./DossierSelect.vue?vue&type=template&id=5c4b79fa&"
import script from "./DossierSelect.vue?vue&type=script&lang=js&"
export * from "./DossierSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports